<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nSVygc/tc-custom/9781488084294.jpg?1728851662367" alt="This image is the cover for the book Scent of Roses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scent of Roses
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times–</i>bestselling author, a woman goes ghost hunting with a handsome stranger in this “genuinely chilling” romantic suspense (<i>RT Book Review</i>).</b><br/><br/> Elizabeth doesn’t believe in ghosts. But this time she has no choice.<br/><br/> Family counselor Elizabeth Conner isn’t sure what to think when Maria Santiago comes to her for help. Pregnant and terrified, Maria claims to be visited each night by the ghost of a little girl, warning her to flee. Her husband, Miguel, a migrant worker at Harcourt Farms in the San Joaquin Valley, dismisses her fears as hormonal changes. Sympathetic to the young woman, Elizabeth agrees to help by contacting Miguel’s employers, who own the cottage where the young couple lives.<br/><br/> Elizabeth immediately picks up on the deep enmity between the two Harcourt brothers: Carson, the handsome scion running the estate for his incapacitated father, and Zack, the rebellious black sheep. While Carson is more interested in Elizabeth than in her concerns, Zack grudgingly agrees to help her look into the history of the house.<br/><br/> But even as unexpected desire draws them together, Elizabeth and Zack feel something dark and disturbing at the house. And when the cloying scent and lingering chill of pure evil surround her, Elizabeth knows something terrible has happened here before, something that has its roots in murder. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kat Martin
      </h2>
      
      <p class="authorDescription body article">Top ten <I>New York</I><I>Times</I> bestselling author Kat Martin is a graduate of the University of California Santa Barbara.&#160; Residing with her Western-author husband, L.J. Martin, in Missoula, Montana, Kat has written 70 Historical and Contemporary Romantic Suspense novels. More than 17 million of her books are in print and she has been published in twenty foreign countries. Kat is currently hard at work on her next novel.&#160;<Br><Br>&#160;<Br><Br>&#160;<Br><Br>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cb130c94